import { colors } from '../constants/colors.js';

var stepperThemeWeb = {
  color: 'secondary',
  align: 'center',
  connector: {
    inactiveColor: colors.fogGrey
  },
  header: {
    activeColor: 'text',
    inactiveColor: colors.fogGrey
  },
  step: {
    valid: {
      textColor: 'background'
    },
    active: {
      backgroundColor: 'background',
      textColor: 'text',
      borderColor: colors.fogGrey
    },
    invalid: {
      backgroundColor: 'background',
      textColor: colors.fogGrey,
      borderColor: colors.fogGrey
    }
  }
};
var stepperThemeNative = {
  color: 'secondary',
  align: 'center',
  connector: {
    inactiveColor: colors.fogGrey
  },
  header: {
    activeColor: 'text',
    inactiveColor: colors.fogGrey
  },
  step: {
    iconColor: 'background',
    valid: {
      textColor: 'background'
    },
    invalid: {
      backgroundColor: 'background',
      textColor: 'text',
      borderColor: colors.fogGrey
    }
  }
};

export { stepperThemeNative, stepperThemeWeb };
